/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorComponent = zod
	.object({
		enabled: zod.boolean().describe('Whether this component is enabled'),
		policy_plan_id: zod.uuid().nullable(),
		policy_plan_version_id: zod.uuid().nullable(),
		position: zod.number().describe('Ordering position')
	})
	.describe('A versioned praetor component');

export type PraetorComponent = zod.input<typeof PraetorComponent>;
export type PraetorComponentOutput = zod.output<typeof PraetorComponent>;
